import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from './AuthContext';

const MEETING_SCOPED_BASE_PATHS = new Set([
    'live-timetable', 'draw', 'draw-export-pdf', 'racecards', 'race-cards',
    'competition-admin', 'entry-admin', 'events-admin', 'banding-helper', 'victor-ludorum',
    'system-settings', 'registration-desk', 'racing-dashboard',
    'commentary', 'club-summary'
]);

export function ProtectedRoute({ component: Component, path, requireAdmin = false, requireAnyRole = null, ...rest }) {
    const { user, loading, rolesLoading, isAdmin, roles } = useAuth();

    if (loading || (user && rolesLoading)) return null;

    return (
        <Route
            path={path}
            {...rest}
            render={(props) => {
                const pathSegments = String(props.location.pathname || '').split('/').filter(Boolean);
                const activeSlug = (pathSegments.length >= 2 && MEETING_SCOPED_BASE_PATHS.has(pathSegments[1]))
                    ? String(pathSegments[0] || '').trim().toLowerCase()
                    : '';
                const liveTimetableTarget = activeSlug ? `/${activeSlug}/live-timetable` : '/live-timetable';

                if (!user) {
                    const returnUrl = `${props.location.pathname || ''}${props.location.search || ''}`;
                    return <Redirect to={`/login?returnUrl=${encodeURIComponent(returnUrl || '/')}`} />;
                }

                if (requireAdmin && !isAdmin) {
                    return <Redirect to={liveTimetableTarget} />;
                }

                if (Array.isArray(requireAnyRole) && requireAnyRole.length > 0) {
                    const allowed = requireAnyRole.some(role => roles.includes(role));
                    if (!allowed) {
                        return <Redirect to={liveTimetableTarget} />;
                    }
                }

                return <Component {...props} />;
            }}
        />
    );
}
